import { getDefaultRequestState } from '@Features/utils/getDefaultRequestState';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RequestFormHeader } from '@Types/index';

interface PassportRequestState {
  passportRequest: RequestFormHeader;
}

const initialState: PassportRequestState = {
  passportRequest: getDefaultRequestState(),
};

const passportRequestSlice = createSlice({
  name: 'passportRequest',
  initialState,
  reducers: {
    setPassportRequest: (
      state: PassportRequestState,
      action: PayloadAction<RequestFormHeader | null>
    ) => {
      const { payload } = action;

      if (payload === null) {
        state.passportRequest = getDefaultRequestState();
      } else {
        state.passportRequest = payload;
      }
    },
  },
});

const { actions } = passportRequestSlice;

export const passportRequestActions = {
  ...actions,
};

export default passportRequestSlice;
